import { TFunction } from 'i18next';

import { HIGHLIGHT, HighLightConfigType } from '~/modules/highlight/constants';
import analytics from '~/services/analytics';

export const PLAGIARISM_MAX_FILE_SIZE = 20000000; //20MB
export const PLAGIARISM_VALID_FILE_EXTENSIONS = ['pdf', 'docx', 'txt'];

export enum DETECTION_STAGE {
  HIGH_LEVEL = 'high_level',
  PARTIAL_LEVEL = 'partial_level',
  HEALTHY_LEVEL = 'healthy_level',
  LOW_LEVEL = 'low_level',
}

export const PlagiarismCheckerTitle = 'Check Plagiarism';

export const DETECTION_EDGE: Record<DETECTION_STAGE, number> = {
  [DETECTION_STAGE.HIGH_LEVEL]: 21,
  [DETECTION_STAGE.PARTIAL_LEVEL]: 11,
  [DETECTION_STAGE.HEALTHY_LEVEL]: 1,
  [DETECTION_STAGE.LOW_LEVEL]: 0,
};

export const IsShowedPlagiarismTutorial = 'is_showed_plagiarism_tutorial_v2';

export const getPlagiarismHighlightConfig = (
  t: TFunction,
): Record<
  | HIGHLIGHT.PLAGIARISM_EXCLUDE_CHECKBOX
  | HIGHLIGHT.PLAGIARISM_REMOVE_PLAGIARISM
  | HIGHLIGHT.PLAGIARISM_DETAILED_REPORT,
  HighLightConfigType
> => {
  return {
    [HIGHLIGHT.PLAGIARISM_EXCLUDE_CHECKBOX]: {
      title: t(
        'highlight:plagiarism.exclude_checkbox',
        'Exclude citations, quotes, bibliography and table of contents',
      ),
      text: t(
        'highlight:plagiarism.simplified_scan.text',
        'The plagiarism checker will not flag these parts of texts as not unique',
      ),
      buttonText: t('general:got_it', 'Got it'),
      placement: 'top',
      onShowCallBack: (): void => {
        analytics.trackEvent('tutorial - show tip', {
          tool: PlagiarismCheckerTitle,
          tip_name: HIGHLIGHT.PLAGIARISM_EXCLUDE_CHECKBOX,
        });
      },
      onSubmitCallback: (): void => {
        analytics.trackEvent('tutorial - click next', {
          tool: PlagiarismCheckerTitle,
          tip_name: HIGHLIGHT.PLAGIARISM_EXCLUDE_CHECKBOX,
        });
      },
    },
    [HIGHLIGHT.PLAGIARISM_REMOVE_PLAGIARISM]: {
      text: t(
        'highlight:plagiarism.remove_plagiarism.text',
        'Use this feature to remove traces of plagiarism in your text to make it unique',
      ),
      placement: 'bottom',
      buttonText: t('general:next', 'Next'),
      onShowCallBack: (): void => {
        analytics.trackEvent('tutorial - show tip', {
          tool: PlagiarismCheckerTitle,
          tip_name: HIGHLIGHT.PLAGIARISM_REMOVE_PLAGIARISM,
        });
      },
      onSubmitCallback: (): void => {
        analytics.trackEvent('tutorial - click next', {
          tool: PlagiarismCheckerTitle,
          tip_name: HIGHLIGHT.PLAGIARISM_REMOVE_PLAGIARISM,
        });
      },
    },
    [HIGHLIGHT.PLAGIARISM_DETAILED_REPORT]: {
      text: t(
        'highlight:plagiarism.detailed_report.text',
        'Get a document with complete information about the text regarding plagiarism content inside',
      ),
      placement: 'bottom',
      buttonText: t('general:finish', 'Finish'),
      onShowCallBack: (): void => {
        analytics.trackEvent('tutorial - show tip', {
          tool: PlagiarismCheckerTitle,
          tip_name: HIGHLIGHT.PLAGIARISM_DETAILED_REPORT,
        });
      },
      onSubmitCallback: (updateUserExtraFields): void => {
        updateUserExtraFields({
          highlights: { [IsShowedPlagiarismTutorial]: true },
        });
        analytics.trackEvent('tutorial - finished', {
          tool: PlagiarismCheckerTitle,
          tip_name: HIGHLIGHT.PLAGIARISM_DETAILED_REPORT,
        });
      },
    },
  };
};
